"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_Action = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Contract_Subject_1 = require("./RTTI_Contract_Subject");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Timing_1 = require("./RTTI_Timing");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
exports.RTTI_Contract_Action = t.recursion('IContract_Action', function () {
    return t.intersection([
        t.type({
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            intent: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            status: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            doNotPerform: t.boolean,
            _doNotPerform: RTTI_Element_1.RTTI_Element,
            subject: t.array(RTTI_Contract_Subject_1.RTTI_Contract_Subject),
            linkId: t.array(t.string),
            _linkId: t.array(RTTI_Element_1.RTTI_Element),
            context: RTTI_Reference_1.RTTI_Reference,
            contextLinkId: t.array(t.string),
            _contextLinkId: t.array(RTTI_Element_1.RTTI_Element),
            occurrenceDateTime: t.string,
            _occurrenceDateTime: RTTI_Element_1.RTTI_Element,
            occurrencePeriod: RTTI_Period_1.RTTI_Period,
            occurrenceTiming: RTTI_Timing_1.RTTI_Timing,
            requester: t.array(RTTI_Reference_1.RTTI_Reference),
            requesterLinkId: t.array(t.string),
            _requesterLinkId: t.array(RTTI_Element_1.RTTI_Element),
            performerType: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            performerRole: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            performer: RTTI_Reference_1.RTTI_Reference,
            performerLinkId: t.array(t.string),
            _performerLinkId: t.array(RTTI_Element_1.RTTI_Element),
            reasonCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            reasonReference: t.array(RTTI_Reference_1.RTTI_Reference),
            reason: t.array(t.string),
            _reason: t.array(RTTI_Element_1.RTTI_Element),
            reasonLinkId: t.array(t.string),
            _reasonLinkId: t.array(RTTI_Element_1.RTTI_Element),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            securityLabelNumber: t.array(RTTI_unsignedInt_1.RTTI_unsignedInt),
            _securityLabelNumber: t.array(RTTI_Element_1.RTTI_Element)
        })
    ]);
});
//# sourceMappingURL=RTTI_Contract_Action.js.map